import './Banner.css';

export const Banner = () => {
    return (<header className="cabecalho">
        <img src='/imagens/banner.png' alt='Logo do Organo'/>
    </header>)
}